import type React from "react";
import { MultiTicketType } from "@b2bportal/air-shopping-api";
import { useFlightSlot } from "@b2bportal/core-flights";
import {
  FareCombinationBanner,
  ReviewFlightCard,
  ReviewWarningCard,
  type useReviewPageContainer,
} from "@tenant/flights";
import { LazyLoading } from "@tenant/ui";

export type FlightReviewPageContentProps = {
  classNames: {
    itinerary: string;
    secondaryContent: string;
    hackerFareWarning: string;
    virtualInterliningWarning: string;
    loading: string;
  };
  detailsFooter?: React.ReactNode;
} & ReturnType<typeof useReviewPageContainer>;

export const FlightReviewPageContent = ({
  context,
  handlers: { goToNextStep },
  classNames,
  detailsFooter,
}: FlightReviewPageContentProps) => {
  const {
    tripDetails,
    fareDetails,
    airports,
    paxPricing,
    isMultiTicket,
    isHackerFare,
    tripType,
  } = context;

  const Slots = useFlightSlot();

  return (
    <>
      {isHackerFare ? (
        <ReviewWarningCard className={classNames.hackerFareWarning} />
      ) : null}

      {isMultiTicket && !isHackerFare ? (
        <div className={classNames.virtualInterliningWarning}>
          <FareCombinationBanner />
        </div>
      ) : null}

      {paxPricing != null && fareDetails != null ? (
        <>
          {tripDetails.slices.map((slice, index) => (
            <div className={classNames.itinerary} key={slice.id || index}>
              <ReviewFlightCard
                tripDetails={tripDetails}
                sliceIndex={index}
                fareDetails={fareDetails}
                airports={airports}
                detailsFooter={detailsFooter}
              />
            </div>
          ))}

          <Slots.ReviewFlightSecondaryContent
            multiTicketType={
              fareDetails.multiTicketType ?? MultiTicketType.single
            }
            className={classNames.secondaryContent}
            paxPricing={paxPricing}
            tripType={tripType}
            onClick={() => goToNextStep()}
          />
        </>
      ) : (
        <LazyLoading className={classNames.loading} />
      )}
    </>
  );
};
